import { useDroppable } from "@dnd-kit/core";
import { ReactNode } from "react";

interface DroppableColumnProps {
  id: string;
  children: ReactNode;
  className?: string;
}

export function DroppableColumn({ id, children, className = "" }: DroppableColumnProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`${className} ${isOver ? "ring-2 ring-primary ring-offset-2 ring-offset-background" : ""} transition-all duration-200`}
    >
      {children}
    </div>
  );
}
